// extracted by mini-css-extract-plugin
export var largeAccordion = "large-accordion-module--largeAccordion--DFSNl";
export var accordionItem = "large-accordion-module--accordionItem--uS1D8";
export var accordionItemOpen = "large-accordion-module--accordionItemOpen--fP+X7";
export var accordionItemImage = "large-accordion-module--accordionItemImage--LsHAu";
export var accordionItemContent = "large-accordion-module--accordionItemContent--MyJch";
export var accordionItemContentFigure = "large-accordion-module--accordionItemContentFigure--nhf+9";
export var accordionItemContentTitle = "large-accordion-module--accordionItemContentTitle--kJcFR";
export var accordionItemContentLink = "large-accordion-module--accordionItemContentLink--wYRsk";
export var accordionItemContentText = "large-accordion-module--accordionItemContentText--XSnBD";